import React, { Component } from "react";
import styles from "./GetQuestion.module.css";
import Aux from "./../../../Auxiliary/Auxiliary";
import Backdrop from "./../../../Backdrop/Backdrop";

class GetQuestion extends Component {
  state = {
    correct: this.props.correct,
    input: "",
  };

  onSubmitHandler = () => {
    if (this.state.input === this.state.correct) {
      this.props.ans(true);
      this.props.score();
    } else this.props.ans(false);
    this.props.click();
  };
  onChangeHandler = (event) => {
    this.setState({ input: event.target.value });
  };
  render() {
    return (
      <Aux>
        <Backdrop show={true} clicked={this.props.click} />
        <div className={styles.box}>
          <div className={styles.question}>{this.props.question}</div>
          <input
            onChange={this.onChangeHandler}
            type="text"
            placeholder="Enter Your Answer"
            className={styles.input} autoFocus
          />
          <button onClick={this.onSubmitHandler} className={styles.submit}>
            Submit
          </button>
        </div>
      </Aux>
    );
  }
}

export default GetQuestion;
